import useJwt from '@core/auth/jwt/useJwt'
import revampAxios from '../../libs/revamp-axios'
import jwtRevampConfig from '@/@core/auth/jwt/jwtRevampConfig'

const { jwt } = useJwt(revampAxios, jwtRevampConfig)
export default jwt
